import classNames from 'classnames';
import PropTypes from 'prop-types';

import { emptyFunction } from '../../utils';

function CaseControlsButtons(props) {
  const {
    children = null,
    name,
    label,
    onClick = emptyFunction,
    disabled,
  } = props;

  const handleClick = () => {
    // console.log(`Click on ${label}`);
    onClick(name);
  };

  const svgDivClassName = classNames(
    'h-7.5 w-7.5 rounded-full p-1 flex justify-center items-center bg-pxAccentBlue',
    {
      'fill-pxAccentBlue bg-pxAccentBlue': !disabled,
      'fill-pxDarkBlue bg-pxDarkBlue': disabled,
    },
  );

  const textClassName = classNames(
    'h-4',
    {
      'text-pxAccentBlue': !disabled,
      'text-pxDarkBlue': disabled,
    },
  );

  return (
    <button
      type="button"
      className="h-full w-17.5 relative flex flex-col justify-around items-center"
      onClick={handleClick}
      disabled={disabled}
    >
      <div className={svgDivClassName}>
        {children}
      </div>
      <div className={textClassName}>
        {label}
      </div>
    </button>
  );
}

CaseControlsButtons.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default CaseControlsButtons;
